<template>
  <div class="card card-box d-block pb-3 bg-transparent shadow-none border-0">
    <slick ref="slick" :options="slickOptions">
      <div v-for="(template, key) in templateNames" class="card-body px-0 text-center">
        <b-button
          v-if="key != 'label'"
          variant="primary"
          pill
          size="sm"
          class="m-3 w-90 p-3 d-inline-block text-center font-size-sm"
          :class="{'btn-secondary': selected === template}"
          @click="select(template)"
        >
          {{$t(template) | capitalize}}
        </b-button>
      </div>
    </slick>
  </div>
</template>

<script>
  import Slick from 'vue-slick';
  export default {
    name: "emailTemplateSlide",
    components: {Slick},
    props: {
      templateNames: []
    },
    data() {
      return {
        slickOptions: {
          adaptiveHeight: true,
          centerPadding: "60",
          centerMode: true,
          infinite: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          speed: 500,
          initialSlide: 3,
          dots: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1
              }
            },
          ]
        },
        selected: null
      }
    },
    methods: {
      select(template) {
        this.selected = template;
        this.$emit('onSelect', template);
      }
    }
  }
</script>

<style scoped>
.w-90 {
  width: 90%;
}
</style>
